export default ({ request }) => ({
    userPaymentRequestListApi(data = {}) {
      return request({
        url: '/financial/user/payment/request/list',
        method: 'POST',
        data,
      })
    },
  })
  